export default "__VITE_ASSET__TyAcepUB__"